/* eslint-disable react/require-default-props */
import React from 'react';
import { VscError } from 'react-icons/vsc';

import { authColors } from 'design-system/tokens';

import {
  Actions,
  Column,
  ErrorTag,
  FormBody,
  Intro,
  OutlineButton,
  PrimaryButton,
  Title,
} from '../AuthForm/styles';
import { ChannelChoice, ChannelList, EmptyChannels } from './styles';

export type AuthChannel = {
  contactId: string;
  contact: string;
  contactType: 'EMAIL' | 'PHONE';
};

export type ChannelStepProps = {
  title: React.ReactNode;
  channels: AuthChannel[];
  contactId: string;
  loading?: boolean;
  erro?: string | null;
  submitLabel?: string;
  loadingLabel?: string;
  emptyMessage?: string;
  onChangeContact: (contactId: string) => void;
  onSubmit: () => void;
  onBack: () => void;
};

export const channelLabel = (channel: AuthChannel): string =>
  channel.contactType === 'EMAIL'
    ? `Via e-mail em: ${channel.contact}`
    : `Via sms em: ${channel.contact}`;

const ChannelStep: React.FC<ChannelStepProps> = ({
  title,
  channels,
  contactId,
  loading = false,
  erro = null,
  submitLabel = 'Enviar código de recuperação',
  loadingLabel = 'Enviando...',
  emptyMessage = 'Não encontramos um canal disponível para enviar o código. Entre em contato com a Central de Atendimento.',
  onChangeContact,
  onSubmit,
  onBack,
}) => {
  const semCanais = channels.length === 0;

  return (
    <Column gap={24}>
      <Intro>
        <Title>{title}</Title>
      </Intro>

      <FormBody>
        <ChannelList>
          {semCanais ? (
            <EmptyChannels>{emptyMessage}</EmptyChannels>
          ) : (
            <ChannelChoice
              color={authColors.textBody}
              value={contactId}
              onChange={onChangeContact}
              options={channels.map((channel) => ({
                value: channel.contactId,
                label: channelLabel(channel),
              }))}
            />
          )}
          {erro && (
            <ErrorTag role="alert">
              <VscError aria-hidden="true" />
              {erro}
            </ErrorTag>
          )}
        </ChannelList>

        <Actions>
          <OutlineButton
            type="button"
            variant="secondary"
            shape="pill"
            fullWidth
            onClick={onBack}
          >
            Voltar
          </OutlineButton>
          <PrimaryButton
            type="button"
            shape="pill"
            fullWidth
            disabled={loading || semCanais || !contactId}
            onClick={onSubmit}
          >
            {loading ? loadingLabel : submitLabel}
          </PrimaryButton>
        </Actions>
      </FormBody>
    </Column>
  );
};

export default ChannelStep;
